import React, { useEffect, useState } from 'react'
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import { Apirequests } from '../../utils/ApiRequests';
import { Save, X } from 'lucide-react';
import BtnSpinner from '../../components/BtnSpinner';

function AddCommonLead({ setRefresh, close,title,leadUrl }) {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        whatsapp_number: "",
    });
    const [loading, setLoading] = useState({ state: false, name: "" });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, whatsapp_number} = formData;

        if (!name || !email || !whatsapp_number ) {
            return ErrorTost("Please Provide valid name,email,whatsapp number.")
        };

        // console.log(formData,'form')
        setLoading({ state: true, name: "addlead" });
        try {
            const addRes = await Apirequests(leadUrl || 'leads/submit-quiz-lead', 'POST', formData, {});
            // console.log(addRes, 'addres');
            if (addRes?.success) {
                SuccessTost(addRes?.message);
                setRefresh((prev) => !prev);
                close();
            } else {
                ErrorTost(addRes?.message)
            }
        } catch (error) {
            console.log("post new lead error");
            ErrorTost("Something went wrong, please try again later.")
        }

        setLoading({ state: false, name: "" })
    };





    return (
        <div>
            <form onSubmit={handleSubmit} className="bg-white rounded-2xl">

                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-3xl font-bold text-gray-900">
                        {title || "Add New Lead"}
                    </h1>
                </div>
                <div>
                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Name *
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Name"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            email *
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Email"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Whatsapp Number
                        </label>
                        <input
                            type="tel"
                            name="whatsapp_number"
                            value={formData.whatsapp_number}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Whatsapp Number"
                        />
                    </div>
                </div>
                <div className="flex gap-4 mt-6">

                    <button
                        type="submit"
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                    >
                        {
                            loading.state && loading.name === "addlead" ?
                                <BtnSpinner /> :
                                <>
                                    <Save className="w-5 h-5" />
                                    <span className='text-white'>Add Lead</span>
                                </>
                        }

                    </button>
                    <button
                        type="button"
                        onClick={() => close()}
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                    >
                        <X className="w-5 h-5" />
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AddCommonLead